import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useContext, useEffect } from 'react';
import { ToolContext } from '../../core/context/ToolContext';
import { VM } from '../../core/VM';
import { Welcome } from './Welcome';
import { Select } from './Select';
import { Index as Dashboard } from '../home/desktop/Index'
import Home from '../home/devices/mobile/Index';

const view = VM()

export const Index = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const { tool_state, ubr_state } = useContext(ToolContext)
    const { __SESSION } = tool_state
    const { ubrModal, welcomeModal } = ubr_state

    const history = useHistory();

    useEffect(() => {
        const __init = () => {
            if (atob(__SESSION.data.ainfo.aid).split('_', 2)[1] !== '0') {
                window.location.href = '/'
                history.push('/')
                return
            }else{
                if (!welcomeModal.data) {
                    ubrModal.set(true)
                }else{
                    if (urlParams.get('filter') !== null) {
                        welcomeModal.set(false)
                        ubrModal.set(true)
                    }
                }
            }
        }
        __init()
        // eslint-disable-next-line
    }, [])

    return (
        atob(__SESSION.data.ainfo.aid).split('_', 2)[1] === '0' && (
            <>
                { view === '' ? 
                    // DESKTOP
                    <Dashboard linkacct={[]}/>
                :  
                    // MOBILE
                    <Home linkacct={[]}/>
                }
                {!welcomeModal.data && (
                    (urlParams.get('type') === 'select' ? 
                        <Select txt="Select the file type you want to upload?"/>
                    :
                        <Welcome ubrModal={ubrModal}/>
                    )
                )}
            </>
        )
    )
}